import { render, staticRenderFns } from "./ClientCampaignView.vue?vue&type=template&id=edfbb030&scoped=true"
import script from "./ClientCampaignView.vue?vue&type=script&lang=js"
export * from "./ClientCampaignView.vue?vue&type=script&lang=js"
import style0 from "./ClientCampaignView.vue?vue&type=style&index=0&id=edfbb030&prod&scoped=true&lang=css"
import style1 from "./ClientCampaignView.vue?vue&type=style&index=1&id=edfbb030&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfbb030",
  null
  
)

export default component.exports